export default __webpack_public_path__ + "static/media/3S2.9c699422.svg";